import {api, pdf} from "../../../services/api/api.service";

export const loadEvent = (id, loading) => api({uri: `/events/${id}`, loading});
export const resultsPdf = ({id, name}, loading) => pdf({uri: `/categories/${id}/results`, loading, filename: `${name}_results.pdf`});
export const combinedResultsPdf = ({id, group, name}, loading) => pdf({uri: `/categories/${id}/results_combined_group`, loading, filename: `${group}_results.pdf`});


